import { render } from "./PanelItem.vue?vue&type=template&id=724b6c54"
import script from "./PanelItem.vue?vue&type=script&lang=js"
export * from "./PanelItem.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"PanelItem.vue"]])

export default __exports__